const TaCategoriesData = [
    {
      title: "விகசனம்",
      subcategories: [
        {
          title: "வலை வளர்ப்பு",
          popularTopics: [
            "ஜாவாஸ்கிரிப்ட்", "ரியாட்க்", "HTML/CSS", "MERN", "டைப் ஸ்கிரிப்ட்", "நோட்.ஜ்", "அங்குலர்", "வியூ.ஜ்", "ஸ்வெல்ட்"
          ]
        },
        {
          title: "மொபைல் வளர்ப்பு",
          popularTopics: [
            "ஃபிளாட்டர்", "ரியாட்க் நேட்டிவ்", "ச்விஃப்ட்", "கோட்டிலின்", "ஆண்ட்ராய்ட் ஸ்டூடியோ", "iOS வளர்ப்பு", "ஜாமரின்", "ஐஒனிக்"
          ]
        },
        {
          title: "நிரலாக்க மொழிகள்",
          popularTopics: [
            "பைதான்", "ஜாவா", "C++", "ஜாவாஸ்கிரிப்ட்", "கோ", "ரூபி", "ராஸ்ட்", "ச்விஃப்ட்", "C#", "PHP"
          ]
        },
        {
          title: "விளையாட்டு வளர்ப்பு",
          popularTopics: [
            "யூனிட்டி", "அனிரியல் என்ஜின்", "C#", "விளையாட்டு வடிவமைப்பு", "3D மாதிரித்தோர்", "AR/VR வளர்ப்பு", "பிளெண்டர்", "கொடோட்"
          ]
        },
        {
          title: "தரவுகள் வடிவமைப்பு & வளர்ப்பு",
          popularTopics: [
            "SQL", "மொங்கோடிபி", "போஸ்ட்‌கிரேஸ்க்யூஎல்", "ஃபையர்பேஸ்", "தரவுகள் கட்டமைப்பு", "NoSQL", "கிராஃப் க்யூஎல்", "கசாண்டிரா"
          ]
        },
        {
          title: "மென்பொருள் சோதனை",
          popularTopics: [
            "செலினியம்", "யூனிட் சோதனை", "சோதனை ஆட்டோமேஷன்", "API சோதனை", "JUnit", "குக்கும்பர்", "சைপ্রஸ்", "அப்பியம்"
          ]
        },
        {
          title: "மென்பொருள் பொறியியல்",
          popularTopics: [
            "மென்பொருள் வடிவமைப்பு முறை", "மைக்ரோசர்வீசுகள்", "டெவ்ஒப்‌ஸ்", "கூட்டு கட்டமைப்பு", "அஜைல்", "ஸ்க்ரம்", "CI/CD"
          ]
        },
        {
          title: "மென்பொருள் வளர்ப்புப் கருவிகள்",
          popularTopics: [
            "கிட்", "டாக்கர்", "கியூபெர்நெட்ஸ்", "ஜென்கின்ஸ்", "CI/CD", "IDE", "டெர்ராஃபோம்", "வாகிரெண்ட்", "கிட்லாப்"
          ]
        },
        {
          title: "நோ-கோடு வளர்ப்பு",
          popularTopics: [
            "வெப்ஃப்ளோ", "பப்ள்", "அடாலோ", "ஜாப்பியர்", "ஏர்டேபிள்", "இன்டிகிரோமேட்", "கிளைடு", "தங்க்பால்"
          ]
        }
      ]
    },
    {
      title: "வணிகம்",
      subcategories: [
        {
          title: "உத்யோகத்துவம்",
          popularTopics: [
            "ஸ்டார்ட்அப்", "நிதி", "வணிக மாடல்", "தயாரிப்பு மேலாண்மை", "லீன் ஸ்டார்ட்அப்", "பிச்சிங்", "ஸ்கேலிங்"
          ]
        },
        {
          title: "விற்பனை",
          popularTopics: [
            "B2B விற்பனை", "வர்த்தகப் பேச்சு", "லீட் உருவாக்கம்", "CRM", "விற்பனை குழாய்", "கொல்லிங்", "மின்னஞ்சல் மார்க்கெட்டிங்"
          ]
        },
        {
          title: "நேற்றிருத்தல் & மேலாண்மை",
          popularTopics: [
            "அணி மேலாண்மை", "நேற்றிருத்தல் திறன்கள்", "அஜைல் நேற்றிருத்தல்", "தந்திர சிந்தனை", "திட்ட மேலாண்மை", "OKRs"
          ]
        },
        {
          title: "வணிகம் பரிசீலனை",
          popularTopics: [
            "தரவை பரிசீலனை", "பவர் BI", "டேபிளோ", "நிதி மாதிரி", "வணிக புத்தி", "தரவை காட்சീകരிப்பு", "எக்செல்"
          ]
        }
      ]
    },
    {
      title: "பணம் & கணக்கீடு",
      subcategories: [
        {
          title: "நிதி கணக்கீடு",
          popularTopics: [
            "சமநிலை பட்டியல்", "வருமானம் அறிக்கை", "GAAP", "IFRS", "ஆடிடிங்", "புக்-கீப்பிங்", "வரி", "க்விக் புத்தகங்கள்"
          ]
        },
        {
          title: "நிறுவன நிதி",
          popularTopics: [
            "மூலதனத்திற்கான பட்ஜெட்", "நிறுவன மதிப்பீடு", "மோசமான மேலாண்மை", "இணைப்பு மற்றும் அதிகாரங்கள்", "முதலீட்டு வங்கிக்குழு", "ஐபிஓ"
          ]
        },
        {
          title: "தனிப்பட்ட நிதி",
          popularTopics: [
            "பட்ஜெட் அமைத்தல்", "சேமிப்பு", "முதலீடு", "சேமிப்பு திட்டங்கள்", "நிதி சுதந்திரம்", "உயர்நிலை", "பங்கு"
          ]
        }
      ]
    },
    {
      title: "ஐடி & மென்பொருள்",
      subcategories: [
        {
          title: "கிளவுட் கணினி",
          popularTopics: [
            "AWS", "அஜூர்", "கூகிள் கிளவுட்", "கியூபெர்நெட்", "சேவையற்ற கட்டமைப்பு", "கிளவுட் பாதுகாப்பு", "டெவ்-ஓப்ஸ்", "ஒப்பந்தங்கள்"
          ]
        },
        {
          title: "சைபர் பாதுகாப்பு",
          popularTopics: [
            "தத்துவமுடி ஹேக்கிங்", "நுழைவுத்திறனை சோதனை", "நெட்வொர்க் பாதுகாப்பு", "கிரிப்டோகரன்சி", "சைபர் அச்சுறுத்தல்கள்", "என்கெர்க்கார்டு", "SOC"
          ]
        },
        {
          title: "நெட்வொர்க்",
          popularTopics: [
            "CCNA", "நெட்வொர்க் நிபந்தனைகள்", "சிஸ்கோ", "SDN", "நெட்வொர்க் பாதுகாப்பு", "ரவுடிங்", "VPN", "स्विचिंग"
          ]
        }
      ]
    },
    {
      title: "வடிவமைப்பு",
      subcategories: [
        {
          title: "கிராபிக் வடிவமைப்பு",
          popularTopics: [
            "போட்டோஷாப்", "இல்லஸ்ட்ரேட்டர்", "இன்டிசைன்", "கேன்வா", "எழுத்தியல்", "எண்ணத்தின் கொள்கை", "சின்ன வடிவமைப்பு", "பிராண்ட்"
          ]
        },
        {
          title: "UI/UX வடிவமைப்பு",
          popularTopics: [
            "பிக்மா", "அடோபெக்ஸ்", "ஸ்கெட்ச்", "கேட் வடிவமைத்தல்", "மாதிரியாக்கம்", "பயனர் ஆராய்ச்சி", "பயனர் சோதனை"
          ]
        },
        {
          title: "3D & அநிமேசன்",
          popularTopics: [
            "பிளெண்டர்", "மாயா", "3D ஸ்டூடியோ மேக்ஸ்", "சினிமா 4D", "அப்டரில் பாத்திரம்", "மோஷன் கிராபிக்ஸ்", "கேர் அநிமேசன்"
          ]
        }
      ]
    },
    {
      title: "மார்கெட்டிங்",
      subcategories: [
        {
          title: "டிஜிட்டல் மார்க்கெட்டிங்",
          popularTopics: [
            "SEO", "கூகிள் விளம்பரம்", "எபிஜெட் விளம்பரம்", "உள்ளடக்கம் மார்க்கெட்டிங்", "சோஷியல் மீடியா மார்க்கெட்டிங்", "PPC", "பல்வேறு டெக்ஸ்"
          ]
        },
        {
          title: "அஃபிலியேட் மார்க்கெட்டிங்",
          popularTopics: [
            "அஃபிலியேட் நெட்வொர்க்", "கமிஷன் கண்காணிப்பு", "உற்பத்தியின் மதிப்பீடுகள்", "அஃபிலியேட் SEO", "மின்னஞ்சல் திட்டங்கள்"
          ]
        },
        {
          title: "பிராண்டிங்",
          popularTopics: [
            "பிராண்ட் திட்டம்", "பிராண்டிங் அடையாளம்", "பிராண்டிங் ஒலி", "கதைகள் கூறுதல்", "பார்வையாளர்களை ஈர்க்கும்", "தொழில்நுட்பம்", "PR"
          ]
        }
      ]
    }
  ];
  
  export default TaCategoriesData;
  